<!-- 教育局-机构课程统计 -->
<template>
  <div class="container">
    <div class="index" v-show="!detail.show">
      <div class="title">
        <span>{{ $route.name }}</span>
        <span style="font-weight: normal;
         margin-left: 70%;
        color:#606266;font-size:14px;">截止日期:{{dayjs(new Date().getTime()-86400000).format('YYYY-MM-DD')}}</span>
      </div>
      <header>
        <div class="header-item">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>机构提供课程数TOP5</span>
          </div>
          <div id="echarts-box1"></div>
        </div>

        <div class="header-item">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>课程开课次数TOP5</span>
          </div>
          <div id="echarts-box2"></div>
        </div>
      </header>

      <div class="query">
        <el-form ref="form" :model="form" label-width="90px"> </el-form>
        <div class="query">
          <el-form ref="form" :inline="true" :model="form" label-width="90px">
            <el-form-item label="">
              <el-select
                v-model="form.schoolYearSemester"
                placeholder="请选择学年学期"
                clearable
              >
                <el-option
                  v-for="item in semesterList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <el-select
                v-model="form.orgId"
                placeholder="请选择机构"
                clearable
              >
                <el-option
                  v-for="item in unitList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <el-button type="primary" size="small" @click="searchFun"
                >搜索</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="table">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
        >
          <el-table-column align="center" prop="orga_name" label="机构名称">
          </el-table-column>
          <el-table-column align="center" prop="go_orga_num" label="提供课程数">
          </el-table-column>
          <!-- <el-table-column align="center" prop="kbNum" label="覆盖区域">
          </el-table-column> -->
          <el-table-column
            align="center"
            prop="scope_name"
            label="课程覆盖年级"
          >
          </el-table-column>
          <el-table-column align="center" prop="period_total" label="课时总数">
          </el-table-column>
          <el-table-column align="center" prop="tea_td" label="机构教师数">
          </el-table-column>
          <el-table-column align="center" prop="orga_num" label="学校开课次数">
          </el-table-column>
          <el-table-column align="center" label="操作" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="toDetail(scope)"
                >查看详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页组件-->
      <el-pagination
        background
        :current-page="page.pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.pageSize"
        :total="page.totalPage"
        layout="total,prev, pager, next,jumper,sizes"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
      ></el-pagination>
    </div>
    <Detail :info="detail.info" v-if="detail.show" @to-index="toIndex"></Detail>
  </div>
</template>

<script>
import {
  handleCurriculumTotal,
  handleCurriculumOpen,
  handleCurriculumList,
} from "@/api/education/statistical.js";
import * as echarts from "echarts";
import dayjs from 'dayjs';
import util from '@/utils/util.js';
export default {
  components: {
    Detail: () => import("./details.vue"),
  },
  data() {
    return {
      form: {
        schoolYearSemester: "",
        orgId: "",
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        totalPage: 0,
      },
      tableData: [],
      unitList: [
        { id: "jg1", label: "果力教育" },
        { id: "jg2", label: "欧美思" },
        { id: "jg3", label: "智课" },
        { id: "jg4", label: "第七感官" },
        { id: "jg5", label: "黑色空间" },
        { id: "jg6", label: "小鱼" },
      ], //机构数据列表
      semesterList: [
        { id: "xq1", label: "2021-2022学年下学期" },
        { id: "xq2", label: "2021-2022学年上学期" },
        { id: "xq3", label: "2020-2021学年下学期" },
        { id: "xq4", label: "2020-2021学年上学期" },
        { id: "xq5", label: "2019-2020学年下学期" },
        { id: "xq6", label: "2019-2020学年上学期" },
      ],
      // semesterArr: JSON.parse(sessionStorage.getItem("semesterList")) || [],
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      dateTime: "",
      educationType: sessionStorage.getItem("educationType") === "area",
      Userlist: JSON.parse(window.sessionStorage.getItem("Userlist")),
      detail: {
        info: {},
        show: false,
      },
      CurriculumTotalData: {
        data: [],
        value: [],
      },
      CurriculumOpenData: {
        data: [],
        value: [],
      },
    };
  },
  mounted() {
    this.unitList = this.userInfo?.user_top_org?.map((v) => ({
      id: v.org_id,
      label: v.org_name,
    }));
    this.init();
    this.getData();
  },
  created() {
    if (this.semesterArr.length > 0) {
      this.semesterList = this.semesterArr.map((v) => ({
        label: v.schoolYear + "年度" + (v.semester === 1 ? "上学期" : "下学期"),
        value: v.schoolYear + "_" + v.semester,
        id: v.id,
      }));
    }
  },
  computed: {},
  methods: {
     dayjs,
    async getData() {
      this.getNowDate();
      this.getCurriculumTotal();
      this.getCurriculumOpen();
      this.getCurriculumList();
    },
    async getCurriculumTotal() {
      try {
        let params = {
          date: this.dateTime, //统计日期,//必填
          coun_code: this.Userlist.area_code,
          prov_code: this.Userlist.province_code,
          city_code: this.Userlist.city_code,
          platform_code: sessionStorage.getItem("platformCode"), //必填
          school_year: "2021-2022", //必填
          term: "2", //必填
        };
        let { code, data } = await handleCurriculumTotal(params);
        if (code === "0") {
          if (data.rows && data.rows.length != 0) {
            data.rows.forEach((it) => {
              this.CurriculumTotalData.data.push(it.go_orga_num);
              this.CurriculumTotalData.value.push(it.orga_name);
            });
          } else {
            this.CurriculumTotalData = {
              data: [0],
              value: ["无"],
            };
          }
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.init();
      }
    },
    async getCurriculumOpen() {
      try {
        let params = {
          date: this.dateTime, //统计日期,
          coun_code: this.Userlist.area_code,
          prov_code: this.Userlist.province_code,
          city_code: this.Userlist.city_code,
          yearly_semester: "",
        };
        let { code, data } = await handleCurriculumOpen(params);
        if (code === "0") {
          if (data.rows && data.rows.length != 0) {
            data.rows.forEach((it) => {
              this.CurriculumOpenData.data.push(it.orga_num);
              this.CurriculumOpenData.value.push(it.name);
            });
          } else {
            this.CurriculumOpenData = {
              data: [0],
              value: ["无"],
            };
          }
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.init();
      }
    },
    async getCurriculumList() {
      try {
        let params = {
          date: this.dateTime, //统计日期, //必填
          coun_code: this.Userlist.area_code,
          prov_code: this.Userlist.province_code,
          city_code: this.Userlist.city_code,
          yearly_semester: "", //2021-2022学年上学期
          platform_code: sessionStorage.getItem("platformCode"), //必填
          school_year: "2021-2022", //必填
          term: "2", //必填
          pagenum: this.page.pageNum,
          pagesize: this.page.pageSize,
        };
        let { code, data } = await handleCurriculumList(params);
        if (code === "0") {
          if (data.rows && data.rows.length != 0) {
            this.tableData = data.rows;
            this.page.totalPage = data.total;
          }
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.init();
      }
    },
    searchFun() {
      this.page.pageNum = 1;
      this.getCurriculumList();
    },
    sizeChangeHandle(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      this.getCurriculumList();
    },

    currentChangeHandle(val) {
      this.page.pageNum = 1;
      this.page.pageNum = val;
      this.getCurriculumList();
    },
    toDetail(scope) {
      console.log(scope);
      this.detail.info = scope.row;
      this.detail.show = true;
    },
    toIndex() {
      this.detail.show = false;
    },
    // 获取当前一天的数据
    getNowDate() {
      this.dateTime = util.getNowDate();
    },
    init() {
      let vm = this;
      this.$nextTick(() => {
        // 柱状图
        let chartDom1 = document.getElementById("echarts-box1");
        let myChart1 = echarts.init(chartDom1);
        let option1 = {
          grid: {
            height: 200,
            top: 30,
            left: 42,
          },
          xAxis: {
            type: "category",
            data: this.CurriculumTotalData.value,
            // splitLine: {show: false},//去除网格分割线
            axisLine: {
              //坐标线
              lineStyle: {
                type: "solid",
                color: "#DDDDDD", //轴线的颜色
                width: "1", //坐标线的宽度
              },
            },
            axisLabel: {
              textStyle: {
                color: "#999999", //坐标值的具体的颜色
              },
              formatter: function (params) {
                var newParamsName = ""; // 最终拼接成的字符串
                var paramsNameNumber = params.length; // 实际标签的个数
                var provideNumber = 5; // 每行能显示的字的个数
                var rowNumber = Math.ceil(paramsNameNumber / provideNumber); // 换行的话，需要显示几行，向上取整
                /**
                 * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
                 */
                // 条件等同于rowNumber>1
                if (paramsNameNumber > provideNumber) {
                  /** 循环每一行,p表示行 */
                  for (var p = 0; p < rowNumber; p++) {
                    var tempStr = ""; // 表示每一次截取的字符串
                    var start = p * provideNumber; // 开始截取的位置
                    var end = start + provideNumber; // 结束截取的位置
                    // 此处特殊处理最后一行的索引值
                    if (p == rowNumber - 1) {
                      // 最后一次不换行
                      tempStr = params.substring(start, paramsNameNumber);
                    } else {
                      // 每一次拼接字符串并换行
                      tempStr = params.substring(start, end) + "\n";
                    }
                    newParamsName += tempStr; // 最终拼成的字符串
                  }
                } else {
                  // 将旧标签的值赋给新标签
                  newParamsName = params;
                }
                //将最终的字符串返回
                return newParamsName;
              },
            },
          },
          yAxis: {
            type: "value",
          },
          tooltip: {
            trigger: "item",
            axisPointer: {
              type: "shadow",
            },
          },
          series: [
            {
              data: this.CurriculumTotalData.data,
              type: "bar",
              showBackground: true,
              backgroundStyle: {
                // 背景颜色
                color: "none", //'#E8F6FF'
              },
              itemStyle: {
                // 柱子颜色
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    // { offset: 0, color: '#009DFD' },
                    { offset: 1, color: "#5BB0FF" },
                  ]),
                  // barBorderRadius: 16, // 柱子圆角, 单位为px
                  label: {
                    formatter: "{c}",
                    show: true,
                    position: "top",
                    textStyle: {
                      fontSize: "12",
                      color: "#999999",
                    },
                  },
                },
              },
              barWidth: 20, //设置柱子宽度，单位为px
            },
          ],
        };
        myChart1.setOption(option1);

        // 柱状图
        let chartDom2 = document.getElementById("echarts-box2");
        let myChart2 = echarts.init(chartDom2);
        let option2 = {
          grid: {
            height: 200,
            top: 30,
            left: 42,
          },
          xAxis: {
            type: "category",
            data: this.CurriculumOpenData.value,
            axisLine: {
              //坐标线
              lineStyle: {
                type: "solid",
                color: "#DDDDDD", //轴线的颜色
                width: "1", //坐标线的宽度
              },
            },
            axisLabel: {
              textStyle: {
                color: "#999999", //坐标值的具体的颜色
              },
              formatter: function (params) {
                var newParamsName = ""; // 最终拼接成的字符串
                var paramsNameNumber = params.length; // 实际标签的个数
                var provideNumber = 4; // 每行能显示的字的个数
                var rowNumber = Math.ceil(paramsNameNumber / provideNumber); // 换行的话，需要显示几行，向上取整
                /**
                 * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
                 */
                // 条件等同于rowNumber>1
                if (paramsNameNumber > provideNumber) {
                  /** 循环每一行,p表示行 */
                  for (var p = 0; p < rowNumber; p++) {
                    var tempStr = ""; // 表示每一次截取的字符串
                    var start = p * provideNumber; // 开始截取的位置
                    var end = start + provideNumber; // 结束截取的位置
                    // 此处特殊处理最后一行的索引值
                    if (p == rowNumber - 1) {
                      // 最后一次不换行
                      tempStr = params.substring(start, paramsNameNumber);
                    } else {
                      // 每一次拼接字符串并换行
                      tempStr = params.substring(start, end) + "\n";
                    }
                    newParamsName += tempStr; // 最终拼成的字符串
                  }
                } else {
                  // 将旧标签的值赋给新标签
                  newParamsName = params;
                }
                //将最终的字符串返回
                return newParamsName;
              },
            },
          },
          yAxis: {
            type: "value",
          },
          tooltip: {
            trigger: "item",
            axisPointer: {
              type: "shadow",
            },
          },
          series: [
            {
              data: this.CurriculumOpenData.data,
              type: "bar",
              showBackground: true,
              backgroundStyle: {
                // 背景颜色
                color: "none", //'#E8F6FF'
              },
              itemStyle: {
                // 柱子颜色
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 1, color: "#51D6A6" },
                  ]),
                  label: {
                    formatter: "{c}",
                    show: true,
                    position: "top",
                    textStyle: {
                      fontSize: "12",
                      color: "#999999",
                    },
                  },
                },
              },
              barWidth: 20, //设置柱子宽度，单位为px
            },
          ],
        };
        myChart2.setOption(option2);
      });
    },
  },
};
</script>
<style scoped>
.el-range-editor {
  width: 120%;
}
.el-range-editor >>> .el-range-separator {
  width: 8%;
}
::v-deep .el-form .el-input__inner {
  width: 189px;
  height: 32px;
  border-radius: 3px;
  background: #fff;
  border: 1px solid #ddd;
}

::v-deep .el-table__header tr th {
  background: #f7f7f7;
  box-shadow: 0px 1px 0px #eaeaea;
}

::v-deep .el-date-editor .el-range-separator {
  line-height: 22px;
}
</style>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  padding: 0 0 2% 2%;
}
.query {
  position: relative;
  margin-bottom: 2%;
}
.searchBtn {
  position: absolute;
  top: 50%;
  right: 5%;
}
.el-pagination {
  margin: 20px 0;
  padding-bottom: 30px;
  text-align: center;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.title {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #eaeaea;
  margin-bottom: 10px;
  span {
    font-family: "PingFang SC Bold";
    font-weight: bold;
    font-size: 20px;
    text-align: left;
    color: #000;
  }
}

header {
  width: 100%;
  height: 350px;
  display: flex;
  .header-item {
    width: 50%;
    .header-item-title {
      font-size: 18px;
      color: #333;
      display: flex;
      align-items: center;
      .circle {
        width: 8px;
        height: 8px;
        display: inline-block;
        background: #4991e1;
        border-radius: 50%;
        margin-right: 10px;
      }
    }
    .header-item-text {
      font-size: 14px;
      color: #666;
      padding-left: 20px;
      margin-top: 5px;
    }
  }
  #echarts-box1,
  #echarts-box2 {
    width: 90%;
    height: 280px;
  }
}
</style>
